export const initialCommunicationLog = {
  _id: "",
  description: "",
  communicated_date: null,
  duration: "",
  mode: "",
  customMode: "",
};

export const patientRPMState = {
  bpReadingsList: [],
  isCommunicationLogModal: false,
  communicationLogAction: "",
  currentCommunicationLog: initialCommunicationLog,
  originalCommunicationLog: initialCommunicationLog,
  currentRpmRowData: {},
  isCommunicationLogCancelModal: false,
  isCommunicationLogDeleteModal: false,
  deletingCommunicationId: null,
  fetchRPMPatientData: false,
  scaleChartData: {},
};
